import type { WastageEntry, WastageListResponse } from '@/services/wastage.service';

// The wastage log is server-paginated (20 rows a page, server cap 100), so an
// export built from the on-screen `entries` only ever held the current page while
// its filename claimed the whole date range (QA 6.10.18). Walk every page of the
// SAME filtered query instead.
export const WASTAGE_EXPORT_PAGE_SIZE = 100;

export async function fetchAllWastageEntries(
  fetchPage: (page: number, limit: number) => Promise<WastageListResponse>,
): Promise<WastageEntry[]> {
  const first = await fetchPage(1, WASTAGE_EXPORT_PAGE_SIZE);
  const rows = [...first.data];
  const totalPages = Math.max(1, first.meta?.total_pages ?? 1);
  for (let page = 2; page <= totalPages; page += 1) {
    const next = await fetchPage(page, WASTAGE_EXPORT_PAGE_SIZE);
    rows.push(...next.data);
  }
  return rows;
}
